var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAL0lEQVR42mNgGIagmuE/XkyRZoKG4FNEtCvIMZwkb1EUmLTVSJFzaRKNZCemIQcA2OFf+6sS8JAAAAAASUVORK5CYII=";
  export default img;